import fr from 'facet-rest';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FDAvatar,
  FDBodyText,
  FDHeadlineText, FDIcon,
  FDLabelText,
  FDPaper,
  FDStack,
} from '@facet-wealth/design';

export const TaxStrategyItemPlannerNote = ({
  itemResource,
}) => {
  return (
    <FDPaper appearance={'outlined'} color={'info'} padding={2}>
      <FDStack direction={'row'} spacing={3}>
        {itemResource?.withRelationship(
          fr.relationships.plannerProfileImage.name,
          (rel) => (
            <FDAvatar
              size={'xl'}
              src={rel.link('related').url()}
              alt={rel.meta('altText')}
            />
          ),
          () => (
            <FDIcon icon={'fac'} size={'lg'} />
          ),
        )}

        <FDStack direction={'column'} spacing={2} paddingY={2}>
          <FDStack direction={'column'}>
            {itemResource.attr('plannerDisplayName') && (
              <FDLabelText size={'lg'} color={'textSecondary'} value={itemResource.attr('plannerDisplayName')} />
            )}
            <FDHeadlineText size={'sm'} value={itemResource.attr('noteTitle')} />
          </FDStack>
          <FDBodyText value={itemResource.attr('note')} />
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

TaxStrategyItemPlannerNote.propTypes = {
  itemResource: PropTypes.instanceOf(fr.Resource).isRequired,
};
